// 俄罗斯语
export const GUIDES = [
  { name: 'guide-overview', title: 'Обзор функций', groupIndex: 0 },
  { name: 'guide-account', title: 'О счете', groupIndex: 0 },
  { name: 'guide-vehicle', title: 'О транспортном средстве', groupIndex: 0 },
  { name: 'guide-meterSetting', title: 'Как настроить приборную панель', groupIndex: 1 },
  { name: 'guide-vehicleSetting', title: 'Как настроить автомобиль', groupIndex: 1 },
  { name: 'guide-findNavigation', title: 'Как найти автомобиль с помощью навигации', groupIndex: 2 },
  { name: 'guide-vehicleNnavigation', title: 'Как пользоваться навигацией', groupIndex: 2 },
  { name: 'guide-cyclingRecord', title: 'Об истории поездок', groupIndex: 3 },
  { name: 'guide-vehicleExperience', title: 'Как провести самопроверку автомобиля', groupIndex: 3 },
  { name: 'guide-useSetting', title: 'Как сделать общие настройки приложения', groupIndex: 3 },
  { name: 'guide-notice', title: 'Как просмотреть и настроить уведомление о сообщении', groupIndex: 3 },
  { name: 'guide-about', title: 'О приложении', groupIndex: 4 },
];

// 息屏引导列表
export const REST_SCREENS = [
  { icon: 'vivo', name: 'vivo', title: 'VIVO' },
  { icon: 'mi', name: 'mi', title: 'MI' },
  { icon: 'huawei', name: 'huawei', title: 'HUAWEI' },
  { icon: 'honor', name: 'honor', title: 'HONOR' },
];

export const FEEDBACK_STATES = {
  0: 'В ожидании',
  1: 'без ответа',
  2: 'ответ',
  3: 'в общении',
  4: 'контрмеры',
  5: 'решено',
};

export const FEEDBACK_TYPES = {
  1: 'Обратная связь',
  2: 'Ответ',
};

export default {
  GUIDES,
  REST_SCREENS,
  FEEDBACK_STATES,
  FEEDBACK_TYPES,
};
